<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="getTitle(resultStatus)"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchaseReceives"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="编号">
            <el-input v-model="purchaseReceives.no" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="单据类型">
            <el-input v-model="purchaseReceives.billType" disabled placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="单据ID">
            <el-input v-model="purchaseReceives.billID" disabled placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="检验类型">
            <el-input
                v-model="purchaseReceives.inspectionType"
                disabled
                placeholder="请输入"
                @click.native="$refs.preview.open(purchase.pkid,'edit')"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="报告状态">
            <el-select v-model.trim="purchaseReceives.status" disabled clearable placeholder="请选择">
              <el-option
                  v-for="item in status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item/>
        </div>
        <el-form-item label="报告结论">
          <el-input v-model="purchaseReceives.conclusion" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="问题描述">
          <el-input v-model="purchaseReceives.problemDesc" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-table
            :data="inspectionMaterials"
            style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-table
                    :data="props.row.inspectionResults"
                    style="width: 100%">
                  <el-table-column label="序号" prop="rowIndex"/>
                  <el-table-column label="编号" prop="no"/>
                  <el-table-column label="名称" prop="name"/>
                  <el-table-column label="检验标准" prop="inspectionStandard"/>
                  <el-table-column label="初检结果" prop="initialInspectionResult" width="135px">
                    <template slot-scope="scope">
                      <el-switch
                          v-model="scope.row.initialInspectionResult"
                          style="display: block"
                          active-color="#ff4949"
                          inactive-color="#13ce66"
                          active-text="NG"
                          active-value="NG"
                          inactive-text="OK"
                          inactive-value="OK"
                          :disabled="resultStatus===40"/>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="resultStatus ===40" label="检验结果" width="135px" prop="inspectionResult">
                    <template slot-scope="scope">
                      <el-switch
                          v-model="scope.row.inspectionResult"
                          style="display: block"
                          active-color="#ff4949"
                          inactive-color="#13ce66"
                          active-text="NG"
                          active-value="NG"
                          inactive-value="OK"
                          inactive-text="OK"/>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="resultStatus ===40" label="ng数量" width="90px">
                    <template slot-scope="scope">
                      <el-input-number
                          v-if="scope.row.inspectionResult === 'NG'"
                          v-model="scope.row.nGNum"
                          style="width: 80px"
                          size="small"
                          :disabled="scope.row.inspectionResult === 'OK'"
                          controls-position="right"
                          :min="1"
                          :max="props.row.inspectionQuantity"/>
                      <el-input-number
                          v-else
                          v-model="val"
                          style="width: 80px"
                          size="small"
                          :disabled="scope.row.inspectionResult === 'OK'"
                          controls-position="right"/>
                    </template>
                  </el-table-column>
                  <el-table-column v-else label="ng数量">
                    <template slot-scope="scope">
                      <el-input-number
                          v-if="scope.row.initialInspectionResult === 'NG'"
                          v-model="scope.row.initialNGNum"
                          style="width: 80px"
                          size="small"
                          :disabled="scope.row.initialInspectionResult === 'OK'"
                          controls-position="right"
                          :min="1"
                          :max="props.row.inspectionQuantity"/>
                      <el-input-number
                          v-else
                          v-model="val"
                          style="width: 80px"
                          size="small"
                          :disabled="scope.row.initialInspectionResult === 'OK'"
                          controls-position="right"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="图片上传" prop="photos">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="$refs.editPicture.open(scope.row.pkid)">上传图片</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="序号" prop="billRowIndex"/>
          <el-table-column label="物料编号" prop="materialNO"/>
          <el-table-column label="物料名称" prop="materialName"/>
          <el-table-column label="收货数量" prop="receiveQuantity"/>
          <el-table-column label="初检数量" prop="inspectionQuantity"/>
        </el-table>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button
            :loading="submitLoading"
            :disabled="purchaseReceives.no === null"
            type="primary"
            @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <preview ref="preview" @save-success="getList(-1)"/>
    <picture-edit ref="editPicture"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import Preview from "@/views/purchase/purchaseReceives/Preview";
  import PictureEdit from "@/views/purchase/purchaseReceives/PictureEdit";

  export default {
    name:"",
    components: {PictureEdit, Preview},
    data() {
      return {
        constant,
        status: constant.toSelect(constant.purchaseStatus, "addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        inspectionMaterials: [],
        resultStatus: "",
        val: 0,
        purchaseReceives: {
          pkid: "",
          receiveId: "",
          no: "",
          billType: "",
          billID: "",
          inspectionType: "",
          inspectorID: "",
          createdTime: "",
          status: "",
          conclusion: "",
          problemDesc: "",
          inspectionMaterials: [],
          note: "",
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.purchaseReceives.pkid = row.pkid;
        this.dialogVisible = true;
        this.resultStatus = row.status;
        if (row.status === 18) {
          this.getData();
        } else {
          this.getNextData();
        }
      },
      getTitle(val) {
        switch (val) {
          case 18:
            return "新增报告";
          case 30:
            return "初检";
          case 40:
            return "复检";
        }
      },
      getData() {
        this.$http
          .get("basic", `inspectionReports/createReportById/${this.purchaseReceives.pkid}`)
          .then(resp => {
            this.purchaseReceives = resp;
            this.inspectionMaterials = resp.inspectionMaterials;
            console.log(this.inspectionMaterials);
          }).catch(() => {
            this.submitLoading = true;
          });
      },
      getNextData() {
        this.$http
          .get("basic", `inspectionReports/selectReportById/${this.purchaseReceives.pkid}`)
          .then(resp => {
            this.purchaseReceives = resp;
            this.inspectionMaterials = resp.inspectionMaterials;
            console.log(this.inspectionMaterials);
          });
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "purchaseReceives", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      handleSubmit() {
        console.log(this.resultStatus);
        if(this.resultStatus ===18) {
          for (let item of this.inspectionMaterials) {
            for (let i of item.inspectionResults) {
              if (i.inspectionResult ==="NG") {
                if(i.nGNum<1) {
                  return this.$message.error("NG数量必须大于0");
                }
              }else {
                i.nGNum = 0;
              }
            }
          }
        }else {
          for (let item of this.inspectionMaterials) {
            for (let i of item.initialInspectionResult) {
              if (i.initialInspectionResult ==="NG") {
                if(i.initialNGNum<1) {
                  console.log(i);
                  return this.$message.error("NG数量必须大于0");
                }
              }else {
                i.initialNGNum = 0;
              }
            }
          }
        }
        this.purchaseReceives.inspectionMaterials = this.inspectionMaterials;
        console.log(this.purchaseReceives.inspectionMaterials);
        if (this.resultStatus === 18) {
          this.handleSubmitSave();
        } else {
          this.handleSubmitUpdate();
        }
      },
      //新增保存
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if (valid) {
            this.$http
              .post("basic", "inspectionReports/insertReport", this.purchaseReceives)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      //初检复检保存
      handleSubmitUpdate() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if (valid) {
            this.$http
              .put("basic", "inspectionReports", this.purchaseReceives)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
